<template>
    <div class="easy_toolbar-container">
        <div class="easy_toolbar-first">
            <div id="l1_Easy_editProfile">
                <Avatar :label="my_profile.nickname.charAt(0).toUpperCase()" size=""
                    style="background-color:#2196F3; color: #ffffff; cursor: pointer;" shape="circle"
                    v-if="!my_profile.avatar" @click="openProfileDialog" />
                <Avatar :image="$utils.getAvatar(my_profile.avatar)" size=""
                    style="background-color:#2196F3; color: #ffffff; cursor: pointer;" shape="circle" v-else
                    @click="openProfileDialog" />


                <div id="p1_profile_Easy">
                    <span id="p1_profile_Nickname" @click="openProfileDialog">{{ my_profile.nickname }}</span>
                    <div id="p1_access_icon" @click="openProfileForDiamond">
                        <Diamond /><span>{{ getPremium() }}</span>
                    </div>
                </div>
            </div>
            <div id="p1_access">
                <div id="p1_coins" @click="showGolds">
                    <Coin /><span>{{ my_profile.golds }}</span>
                </div>
            </div>
        </div>
        <div class="easy_toolbar-second">
            <Button severity="secondary" icon="pi pi-arrow-left" v-if="isMobile" @click="back"></Button>

            <div class="easy_toolbar-left">
                <Hashtag v-if="!selected.private && dockMenuValue == 'chat'" class="hashtag_icon" />
                <div class="hashtag_icon" v-if="selected.private && dockMenuValue == 'chat'">
                    <Avatar :label="selected.name.charAt(0).toUpperCase()"
                        style="background-color:#2196F3; color: #ffffff; margin-left:10px; margin-right: 10px;"
                        shape="circle" v-if="!selected.avatar" />
                    <Avatar :image="$utils.getAvatar(selected.avatar)"
                        style="background-color:#2196F3; color: #ffffff; margin-left:10px; margin-right: 10px;"
                        shape="circle" v-else />
                </div>
                <span id="tActiveName_Easy">{{ getSelectedName }}</span>
            </div>
            <div class="easy_toolbar-right" v-if="dockMenuValue == 'chat'">


                <Button severity="secondary" icon="pi pi-phone" v-if="selected.private" @click="call"></Button>
                <Button severity="secondary" icon="pi pi-gift" v-if="selected.private" @click="gift"></Button>
                <Button severity="secondary" icon="pi pi-hourglass" class="waiting_icon"
                    v-if="!selected.private && selected.is_audio && selected.user_access > 10" @click="showWaitingList"
                    :badge="selected.waiting.length.toString()" />

                <Button severity="secondary" @click="toggleTopic" v-if="!selected.private">
                    <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px"
                        fill="var(--p-button-secondary-color)">
                        <path
                            d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Zm-286 80h252l-46-46v-314H400v314l-46 46Zm126 0Z" />
                    </svg>
                </Button>



                <Popover ref="opPopoverWaitingList" appendTo="body" class="p-popper-pinned"
                    v-if="selected.is_audio && selected.user_access > 10">
                    <div v-if="waitingList.length > 0">
                        <span class="waiting_list_title">{{ $t('call.waiting_list') }}</span>
                        <ul class="easy_audio_waiting_list">
                            <li v-for="user in waitingList" :key="user.id">
                                <span class="nickname_waiting">{{ user.nickname }}</span>
                                <i class="pi pi-check" @click="acceptAudio(user)"></i>
                                <i class="pi pi-times" @click="declineAudio(user)"></i>
                            </li>
                        </ul>
                    </div>
                    <div v-if="tempList.length > 0">
                        <span class="waiting_list_title">{{ $t('call.temp_list') }}</span>
                        <ul class="easy_audio_waiting_list">
                            <li v-for="user in tempList" :key="user.id">
                                <span class="nickname_waiting">{{ user.nickname }}</span>
                                <i class="pi pi-check" @click="acceptAudio(user)"></i>
                                <i class="pi pi-times" @click="declineAudio(user)"></i>
                            </li>
                        </ul>
                    </div>

                </Popover>


                <Popover ref="opPopover" appendTo="body" class="p-popper-pinned">
                    <div class="pinned_message">
                        <h4>{{ $t('channel_settings.topic') }}</h4>
                        <div v-html="selected.topic ? selected.topic : $t('channel_settings.no_topic')" class="topic">
                        </div>
                    </div>
                </Popover>
                <Popover ref="opDropDown">
                    <div class="flex flex-col gap-4 w-[25rem]">
                        <ul class="list-none p-0 m-0 flex flex-col gap-1">
                            <li>
                                <Button severity="secondary" :label="$t('call.audio')" icon="pi pi-phone" @click="audioCall"
                                    size="small" />
                            </li>
                            <li>
                                <Button severity="secondary" :label="$t('call.video')" icon="pi pi-video" @click="videoCall"
                                    size="small" />
                            </li>
                        </ul>
                    </div>
                </Popover>
            </div>
        </div>
        <div class="easy_toolbar-third" v-if="dockMenuValue == 'chat'">
            <Button type="button" severity="secondary" icon="pi pi-users" :badge="userCount.toString()" outlined
                badgeSeverity="contrast" @click="toogleUsersList" v-if="!selected.private && dockMenuValue == 'chat'" />

            <Button :icon="icon" severity="secondary" @click="toggleColorScheme()" outlined v-if="!isMobile" />
            <Button type="button" severity="secondary" icon="pi pi-bell" :badge="getBadge" badgeSeverity="contrast"
                outlined @click="toogleNotifications" v-if="!isMobile" />
            <Button icon="pi pi-question-circle" severity="secondary"  outlined v-if="!isMobile"
                @click="showHelp" />


            <Button v-if="my_profile.access || isMobile" severity="secondary" type="button" icon="pi pi-ellipsis-v"
                @click="toggleAdminMenu" aria-haspopup="true" aria-controls="easy_admin_menu" />
            <Menu v-if="my_profile.access || isMobile" ref="easy_admin_menu" id="easy_admin_menu" :model="admin_items"
                :popup="true" />


        </div>
    </div>
</template>

<script>

import Hashtag from './icons/Hashtag.vue';
import Diamond from './icons/Diamond.vue';
import Coin from './icons/Coin.vue';

export default {
    props: ['selected', 'my_profile', 'dockMenuValue', 'userCount', 'notifications', 'isMobile', 'basicMode'],
    data() {
        return {
            icon: 'pi pi-sun',
            topic: '',
            admin_items: [

            ]
        }
    },
    components: {
        Hashtag,
        Diamond,
        Coin
    },

    computed: {
        getBadge() {
            const unreadCount = this.notifications.filter(notification => notification.unread).length;
            if (unreadCount > 0) {
                return unreadCount.toString();
            }
            return '';
        },
        waitingList() {
            return this.selected.waiting.filter(user => !user.accepted);
        },
        tempList() {
            return this.selected.waiting.filter(user => user.accepted);
        },
        getSelectedName() {
            if (this.dockMenuValue == 'chat') {
                return this.selected.name;
            } else {
                switch (this.dockMenuValue) {
                    case 'following':
                        return this.$t('dockmenu.following');
                    case 'matches':
                        return this.$t('dockmenu.matches');
                    case 'reels':
                        return this.$t('dockmenu.reels');
                    case 'live':
                        return this.$t('dockmenu.live');
                    case 'settings':
                        return this.$t('dockmenu.settings');
                    default:
                        return '';
                }
            }
        }
    },
    methods: {
        toggleAdminMenu(event) {
            this.$refs.easy_admin_menu.toggle(event);
        },
        getPremium() {
            if (this.my_profile.is_premium) {
                return this.$t('premium.on');
            } else {
                return this.$t('premium.off');
            }
        },
        toggleTopic(event) {
            this.$refs.opPopover.toggle(event);
        },
        showWaitingList(event) {
            this.$refs.opPopoverWaitingList.show(event);
        },
        call(event) {
            this.$refs.opDropDown.toggle(event);
        },
        audioCall() {
            this.$refs.opDropDown.hide();
            this.$emit('send-events', { action: 'audio-call' });
        },
        toogleNotifications() {
            this.$emit('send-events', { action: 'open-notifications' });
        },
        videoCall() {
            this.$refs.opDropDown.hide();
            this.$emit('send-events', { action: 'video-call' });
        },
        showGolds() {
            this.$emit('send-events', { action: 'open-credit-dialog' });
        },
        showHelp() {
            this.$emit('send-events', { action: 'open-support' });
        },
        back() {
            this.$emit('send-events', { action: 'set-dock-menu', value: 'mobile_conversations' });
        },
        gift() {
            this.$refs.opDropDown.hide();
            this.$emit('send-events', { action: 'send-gift', user: { user_id: this.selected.user_id, nickname: this.selected.name, avatar: this.selected.avatar } });
        },
        toggleColorScheme() {
            const root = document.getElementsByTagName('html')[0];
            if (root.classList.contains("p-dark")) {
                this.$emit('update-theme', 'light');
            } else {
                this.$emit('update-theme', 'dark');
            }

            this.updateIcon();
        },
        updateIcon() {
            const root = document.getElementsByTagName('html')[0];
            if (root.classList.contains("p-dark")) {
                this.icon = 'pi pi-moon';
            } else {
                this.icon = 'pi pi-sun';
            }
        },

        openProfileDialog() {
            this.$emit('send-events', { action: 'open-profile' });
        },
        toogleUsersList() {
            this.$emit('send-events', { action: 'open-users' });
        },
        openProfileForDiamond() {
            this.$emit('send-events', { action: 'open-diamond-dialog' });
        },
        acceptAudio(user) {
            this.$socket.emit('acceptAudioAccess', { channel_id: this.selected.id, user_id: user.user_id, type: 'temporary' });
        },
        declineAudio(user) {
            this.$socket.emit('removeAudioAccess', { channel_id: this.selected.id, user_id: user.user_id });
        }

    },
    mounted() {
        this.updateIcon();

    },
    unmounted() {

    },
    watch: {
        'selected.topic'(newValue) {
            this.topic = newValue;
        },
        selected() {
            this.admin_items = [];


            if (this.basicMode) {
                this.admin_items.push(
                    {
                        label: this.$t('sidebar.menu'),
                        command: () => {
                            this.$emit('send-events', { action: 'open-settings'});
                        }
                    }
                )
            }
            if (this.selected.private) {
                this.admin_items.push(
                    {
                        label: this.$t('sidebar.close_window'),
                        command: () => {
                            this.$emit('send-events', { action: 'close-private', id: this.selected.id });
                        }
                    }
                )
                this.admin_items.push(
                    {
                        label: this.$t('sidebar.delete_private_conversation'),
                        command: () => {
                            this.$emit('send-events', { action: 'remove-private', id: this.selected.id });

                        }
                    }
                )
            } else {
                this.admin_items.push(
                    {
                        label: this.$t('sidebar.manage_channel'),
                        command: () => {
                            this.$socket.emit('manageChannel', this.selected.id);
                        }
                    }
                )
                this.admin_items.push(
                    {
                        label: this.$t('sidebar.part_channel'),
                        command: () => {
                            this.$socket.emit('part', {id: this.selected.id} );
                        }
                    }
                )
            }
            if (this.my_profile.access) {
                this.admin_items.push(
                    {
                        label: this.$t('sidebar.adminDashboard'),
                        command: () => {
                            window.open(this.$socket_url+'/dashboard?token=' + this.$socket.authKeyUnique.auth, '_blank').focus();
                        }
                    }
                )
                this.admin_items.push(
                    {
                        label: this.$t('sidebar.black_list'),
                        command: () => {
                            this.$socket.emit('kline-list');
                        }
                    }
                )
            }
        }
    }

};
</script>

<style scoped>
.easy_toolbar-container {
    display: inline-block;
    width: 100%;
    height: 50px;
    background-color: var(--p-neutral-100);
    border-bottom: 1px solid var(--p-neutral-300);
    padding: 0 20px;
    padding-left: 5px;
}



.pinned_message {
    max-height: 600px;
    overflow-y: auto;
    width: 360px;

}

.pinned_message h4 {
    margin-top: 0;
    padding: 17px;
    font-weight: 200;
    background-color: var(--p-neutral-300);
    color: var(--p-neutral-600);

}

.pinned_message .topic {
    padding: 10px;
    padding-left: 17px;
    padding-top: 0;
}

.easy_toolbar-container {
    display: flex;

}

.easy_toolbar-first {
    width: 314px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.easy_toolbar-second {
    flex-grow: 1;
    display: flex;
    border-left: 1px solid var(--p-neutral-200);
    justify-content: space-between;
}

.easy_toolbar-left,
.easy_toolbar-right {
    padding: 10px;
}

.easy_toolbar-left {
    text-align: left;
    display: flex;
    align-items: center;
}

.easy_toolbar-right {
    display: flex;
    align-items: center;
    text-align: right;
    gap: 5px;

}


.easy_toolbar-third {
    width: 221px;
    display: flex;
    border-left: 1px solid var(--p-neutral-200);
    justify-content: end;
    align-items: center;
    gap: 5px;
}

.this_private_layout .easy_toolbar-third {
    width: 356px;
}

div#l1_Easy_editProfile {
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 3px 10px;
    border-radius: 5px;
}

div#l1_Easy_editProfile * {
    cursor: pointer;
}

div#p1_profile_Easy {
    max-width: 120px;
    display: flex;
    flex-direction: column;
    padding-left: 10px;
}

span#p1_profile_Nickname {
    font-weight: 600;
}

div#l1_Easy_editProfile .pi-cog {
    font-size: 16px;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: 10px;
}

div#p1_access {
    margin-left: auto;
    display: flex;
    justify-content: space-between;
}

#p1_access svg {
    margin-right: 5px;
}

#p1_access div {
    display: flex;
    align-items: center;
    justify-content: center;
}

#p1_coins,
#p1_access_icon {
    margin-right: 5px;
    padding: 3px 10px;
    border-radius: 5px;
    cursor: pointer;

}

#p1_coins {
    font-weight: bolder;
    font-size: 13px;
    background-image: var(--gradient--background-brand-gradient-coins);

}

#p1_access_icon {
    cursor: pointer;
    padding-left: 0;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bolder;
}

#p1_coins:hover,
#p1_access_icon:hover {
    background: var(--p-neutral-200);
}



@media screen and (max-width: 768px) {
    .easy_toolbar-first {
        display: none;
    }

    #s1_Easy {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 1000;
    }

    .easy_toolbar-third {
        width: auto!important;
    }


    .easy_toolbar-container {
        padding: 0;
    }

    .easy_toolbar-second {
        justify-content: start;
    }

    .easy_toolbar-right {
        margin-left: auto
    }

}

span.waiting_list_title {
    width: 220px;
    padding: 5px 11px;
    display: inline-block;
    margin-top: 5px;
    border-bottom: 1px solid #ccc;
}
</style>
